import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import Button from 'react-bootstrap/Button'
import { useNavigate } from 'react-router-dom'

import { toastErrorLog } from '../../helpers/toastErrorLog.js'
import { obtenerPrecioUnitarioMayorista, toNumber } from '../helpers/calcularPrecioTotal.js'
import Imagen from '../imagen/Imagen.jsx'
import { InputConTextoSugerencia } from '../reutilizables/inputConTextoSugerencia/InputConTextoSugerencia.jsx'
import Precios from '../reutilizables/precios/Precios'
import { SumarProductos } from '../reutilizables/sumarProductos/SumarProductos.jsx'
import * as carritoService from './../servicios/carritoService'
import styles from './CarritoItem.module.css'

const CarritoItem = (props) => {
  const { centroDeCostos, adjunto, loadingImagenes } = props
  const [cantidad, setCantidad] = useState(props.item.cantidad)
  const cantDisponible = props.item.cantDisponible
  const [sugerencias, setSugerencias] = useState([])
  const [sugerenciasImputacion, setSugerenciasImputacion] = useState([])
  const [sugerenciasCodMat, setSugerenciasCodMat] = useState([])

  const sumar = () => {
    if (cantidad < cantDisponible) {
      setCantidad(cantidad + 1)
      props.sumar(props.totalSuma + props.item.precioUnitario)
    }
  }

  const restar = () => {
    if (cantidad > 1) {
      setCantidad(cantidad - 1)
      props.sumar(props.totalSuma - props.item.precioUnitario)
    }
  }

  const navigate = useNavigate()
  const isMounted = useRef(false)

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return
    }

    const carrito = {
      idPublicacion: props.item.idPublicacion,
      idUsuario: parseInt(localStorage.getItem('idUsuario')),
      cantidad: cantidad,
      idEstado: 1
    }

    const actualizarCarrito = async (carrito) => {
      try {
        await carritoService.actualizar(carrito)
      } catch (error) {
        const mensaje = `Ocurrió un error al actualizar el carrito.`
        toastErrorLog(error, mensaje, 'carrito')
      }
    }
    actualizarCarrito(carrito)
    props.setItems((prevItems) =>
      prevItems.map((item) =>
        item.idPublicacion === carrito.idPublicacion
          ? { ...item, cantidad: carrito.cantidad }
          : item
      )
    )
  }, [cantidad])

  const handleSelectSugerencias = (descripcion, propiedad) => {
    props.modificarCarrito(descripcion.descripcion, propiedad, props.item.idPublicacion)
    setSugerencias([])
    setSugerenciasImputacion([])
    setSugerenciasCodMat([])
  }

  const handleChange = (texto, propiedad, setSugerencias, array) => {
    props.modificarCarrito(texto, propiedad, props.item.idPublicacion)
    setSugerencias(
      texto.trim() === ''
        ? []
        : array.filter(
            (opcion) => opcion.codigo?.includes(texto) || opcion.descripcion?.includes(texto)
          )
    )
  }

  const copiarImputacion = (categoria, value) => {
    props.copiar(categoria, value)
    props.copiar('imputacionTipo', props.item.imputacionTipo)
  }

  const obtenerPrecioUnitario = () => {
    const precioMayorista = obtenerPrecioUnitarioMayorista(props.item, cantidad)
    if (precioMayorista > 0) return precioMayorista

    const totalConIva = toNumber(props.item.valorTotalConIva)
    const cant = toNumber(cantidad) || 1
    return cant > 0 ? totalConIva / cant : 0
  }

  const esMayorista = () => {
    if (!props.item.preciosMayoristas || props.item.preciosMayoristas.length === 0) {
      return false
    }

    return props.item.preciosMayoristas.some((precioMayorista) => {
      const cantTier = toNumber(precioMayorista.cantidad)
      const precioTier = toNumber(precioMayorista.precioUnitario)
      return cantTier > 0 && precioTier > 0 && cantidad >= cantTier
    })
  }

  const porcDcto = Number(props.item.porcDcto) || 0
  const tieneDescuento = porcDcto > 0 && porcDcto < 100

  const precioUnitarioFinal = obtenerPrecioUnitario()
  const precioOriginal = tieneDescuento ? precioUnitarioFinal : null

  return (
    <>
      <div className={`d-flex flex-wrap align-items-center mb-3 ${styles.carritoItem}`}>
        <div className={`${styles.carritoRow} mb-5`}>
          <div className={`text-center ${styles.celdaImagen}`}>
            <Imagen
              adjunto={adjunto}
              loadingImagenes={loadingImagenes}
              width={'100px'}
              height={'100px'}
            />
          </div>

          <div className={styles.celdaTitulo}>
            <Button
              variant="link"
              onClick={() => navigate(`/Publicacion/${props.item.idPublicacion}`)}
            >
              {props.item.titulo}
            </Button>
          </div>

          <div
            className={`d-flex align-items-center justify-content-center ${styles.celdaCantidad}`}
            style={{ width: '100%' }}
          >
            <div className="d-flex flex-column align-items-center gap-1">
              <SumarProductos
                cantidad={cantidad}
                setCantidad={setCantidad}
                decrementar={restar}
                incrementar={sumar}
                cantDisponible={cantDisponible}
                agregarAlCarrito={null}
              />
            </div>
          </div>
          <div
            className={styles.celdaPrecios}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              width: '100%',
              justifyContent: 'center'
            }}
          >
            <Precios
              precio={precioUnitarioFinal}
              monedaSimbolo={props.item.monedaSimbolo}
              alicuota={props.item.alicuota}
              cantidad={cantidad}
              showSinIVA={true}
              porcDcto={porcDcto}
              precioOriginal={precioOriginal}
              mostrarDescuento={tieneDescuento}
              tieneDescuento={tieneDescuento}
              sufijo={esMayorista() ? '(mayorista)' : ''}
              className={styles['carritoitem__precios-item']}
            />
          </div>

          <div className={`text-center ${styles.celdaEliminar}`} style={{ width: '100%' }}>
            <Button
              variant="light"
              onClick={() => props.onDelete(props.item.idPublicacion)}
              className={styles.btnBackground}
            >
              <i className={`bi bi-trash-fill ${styles.btnIconColor}`}></i>
            </Button>
          </div>
        </div>
        <div
          className={`d-flex flex-wrap align-items-center ${styles.marginLeft} mb-2 ${styles.gapBloque2}`}
        >
          <InputConTextoSugerencia
            texto={'Código de material'}
            codigo={`codMat-${props.item.codigo}`}
            value={props.item.codMat || ''}
            copiar={props.copiar}
            setSugerencias={setSugerenciasCodMat}
            arrayChance={centroDeCostos?.catalogoMateriales}
            sugerencias={sugerenciasCodMat}
            categoria={'codMat'}
            handleSelectSugerencias={handleSelectSugerencias}
            handleChange={handleChange}
          />
          <InputConTextoSugerencia
            texto={'Planta'}
            codigo={`inputPlanta-${props.item.codigo}`}
            value={props.item.valorPlanta || ''}
            copiar={props.copiar}
            setSugerencias={setSugerencias}
            arrayChance={centroDeCostos?.usuariosPlantaEfectiva}
            sugerencias={sugerencias}
            categoria={'valorPlanta'}
            handleSelectSugerencias={handleSelectSugerencias}
            handleChange={handleChange}
          />

          <InputConTextoSugerencia
            texto={'Imputación'}
            codigo={`imputacion-${props.item.codigo}`}
            value={props.item.imputacionTipo || ''}
            copiar={props.copiar}
            arrayChance={centroDeCostos?.opcionesImputTpos}
            categoria={'imputacionTipo'}
            modificarCarrito={props.modificarCarrito}
            idPublicacion={props.item.idPublicacion}
          />

          {props.item.imputacionTipo && (
            <InputConTextoSugerencia
              texto={
                centroDeCostos?.opcionesImputTpos?.find(
                  (opcion) => opcion.value === props.item.imputacionTipo
                )?.label
              }
              codigo={`inputPlanta-${props.item.codigo}`}
              value={props.item.imputacionTipoOpcion || ''}
              copiar={copiarImputacion}
              setSugerencias={setSugerenciasImputacion}
              arrayChance={centroDeCostos?.listaImputaciones?.filter(
                (opcion) => opcion.value === props.item.imputacionTipo
              )}
              sugerencias={sugerenciasImputacion}
              categoria={'imputacionTipoOpcion'}
              handleSelectSugerencias={handleSelectSugerencias}
              handleChange={handleChange}
            />
          )}
        </div>
      </div>
      <hr />
    </>
  )
}

CarritoItem.propTypes = {
  centroDeCostos: PropTypes.object,
  item: PropTypes.shape({
    cantidad: PropTypes.number,
    cantDisponible: PropTypes.number,
    precioUnitario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valorTotalConIva: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valorTotalSinIva: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cantidadMayorista: PropTypes.number,
    monedaSimbolo: PropTypes.string,
    titulo: PropTypes.string,
    codMat: PropTypes.string,
    codigo: PropTypes.string,
    valorPlanta: PropTypes.string,
    imputacionTipo: PropTypes.string,
    imputacionTipoOpcion: PropTypes.string,
    alicuota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    preciosMayoristas: PropTypes.array,
    porcDcto: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  sumar: PropTypes.func.isRequired,
  totalSuma: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setItems: PropTypes.func.isRequired,
  modificarCarrito: PropTypes.func.isRequired,
  copiar: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  adjunto: PropTypes.shape({
    url: PropTypes.string.isRequired,
    nombre: PropTypes.string,
    idPublicacion: PropTypes.number
  }),
  loadingImagenes: PropTypes.bool.isRequired
}

export default CarritoItem
